import { useMutation, useQueryClient } from 'react-query'
import { postJSON } from 'common/services/api'
import dayjs from 'dayjs'
import { STOCK_LOGS_QUERY_KEY } from './queryConstants'
import { DeliveryData } from '../modalsV2/DeliveryModal'

type UseDeliveryProps = {
  residentId: string
  residentMedicationId: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

type DeliveryMedication = {
  residentId: string
  residentMedicationId: string
  quantity: number
  notes: string
}

type DeliveryBatchItem = {
  medications: DeliveryMedication[]
  deliveryDate: string
  deliveryNotes: string
  witnessIds: string[]
  mediaAttachments: any[]
}

export const useDelivery = ({
  residentId,
  residentMedicationId,
  onSuccess,
  onError
}: UseDeliveryProps) => {
  const queryClient = useQueryClient()

  const mutation = useMutation(
    (data: DeliveryData) => {
      const deliveryDateISO = data.receiveDate
        ? dayjs(data.receiveDate, 'DD-MM-YYYY').toISOString()
        : new Date().toISOString()

      const medication: DeliveryMedication = {
        residentId,
        residentMedicationId,
        quantity: data.receivedStock,
        notes: data.description
      }

      const batchItem: DeliveryBatchItem = {
        medications: [medication],
        deliveryDate: deliveryDateISO,
        deliveryNotes: data.description,
        witnessIds: [],
        mediaAttachments: []
      }

      return postJSON({
        url: '/emar/medication-stock-records/delivery/batch',
        json: [batchItem]
      })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([STOCK_LOGS_QUERY_KEY])
        onSuccess?.()
      },
      onError: (error) => {
        console.error('Error saving delivery:', error)
        onError?.(error)
      }
    }
  )

  return {
    createDelivery: mutation.mutateAsync,
    isLoading: mutation.isLoading
  }
}

export default useDelivery

